import { useState, useEffect, useCallback } from 'react';
import { getUnifiedGatewayBaseUrl } from './apiUrlResolver';

interface ApiSpec {
  servers?: Array<{ url: string; description: string }>;
  [key: string]: unknown;
}

interface UseApiSpecReturn {
  apiSpec: ApiSpec | null;
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

let cachedApiSpec: ApiSpec | null = null;

const useApiSpec = (): UseApiSpecReturn => {
  const [apiSpec, setApiSpec] = useState<ApiSpec | null>(cachedApiSpec);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(!cachedApiSpec);

  const fetchApiSpec = useCallback(async () => {
    try {
      setLoading(true);
      const baseUrl = getUnifiedGatewayBaseUrl();
      const response = await fetch(`${baseUrl}/api/v1/openapi.json`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const spec = await response.json();
      spec.servers = [
        { url: baseUrl, description: 'Live Server' },
      ];
      cachedApiSpec = spec;
      setApiSpec(spec);
      setError(null);
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Failed to fetch API spec';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!cachedApiSpec) {
      fetchApiSpec();
    }
  }, [fetchApiSpec]);

  return { apiSpec, loading, error, refetch: fetchApiSpec };
};

export default useApiSpec;
